// extracted by mini-css-extract-plugin
module.exports = {"Control":"css-modules_Control__8vljN","Track":"css-modules_Track__ydQFc","Indicator":"css-modules_Indicator__d1_ur","Thumb":"css-modules_Thumb__j5iuG"};